"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default(arr, func) {
  var l = arr.length;

  for (var i = 0; i < l; i++) {
    var _item = arr[i];
    func(_item);
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud-fe/react-components/lib/utils/each.js
// module id = 1995
// module chunks = 6 7 17 18